module.exports = __webpack_public_path__ + "static/img/geotap-game-lucre-games-ios-android-casual-mobile-game-promo-2.afdbac2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/promo/geotap-game-lucre-games-ios-android-casual-mobile-game-promo-2.png
// module id = xn4w
// module chunks = 0